import React from 'react';
import './Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <footer>
        Activities Assistant by <a href="https://github.com/beckibloom">beckibloom</a>
      </footer>
    );
  };
};

export default Footer;